import * as React from "react";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import MKButton from "../../components/MKButton";
import MKTypography from "../../components/MKTypography";
import Alert from "@mui/material/Alert";
import Grid from "@mui/material/Grid";
import MKBox from "../../components/MKBox";
import colors from "../../assets/theme/base/colors";
function CountdownDialog(props) {
  const { onClose, open, setOpen, handleLogout, count, marginTop } = props;
  const [clickComplete, setClickComplete] = useState(false);

  const handleClose = () => {
    onClose("no");
  };

  const handleClickOpen = () => {
    setClickComplete(false);
    onClose("yes");
  };

  useEffect(() => {
    setClickComplete(false);
  }, []);

  const onCompleteTimer = () => {
    setOpen(false); // setClickComplete(true)
    handleLogout();
  };

  const Completionist = () => <span>00:00</span>;
  // Renderer callback with condition
  const renderer = ({ minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    } else {
      // Render a countdown
      return (
        <span>
          {("00" + minutes).slice(-2)}:{("00" + seconds).slice(-2)}
        </span>
      );
    }
  };
  return (
    <Dialog
      open={open}
      p={5}
      mt={10}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      container={() => document.getElementById("parent-div")}
      maxWidth="900"
      sx={{ width: "600" }}
    >
      <DialogTitle id="alert-dialog-title">{"Session Timeout"}</DialogTitle>
      <DialogContent>
        <Grid container p={-2}>
          <Grid item xs={12} width={600}>
            <Alert severity="info">
              <MKTypography
                fontSize={17}
                style={{
                  marginTop: "-0.22em",
                  fontFamily: "Barlow",
                  color: colors.JTC.jtcdark3,
                  fontWeight: "500",
                }}
              >
                Your session is about to expire. You will be automatically
                signed out in
              </MKTypography>

              <div></div>
              <Grid
                container
                ml={-1}
                color={colors.JTC.jtcdark3}
                alignItems="end"
                justifyContent="end"
              >
                <Grid item xs={12} alignItems="end" justifyContent="end">
                  <MKBox
                    width="100%"
                    display="flex"
                    mb={1}
                    flexDirection="column"
                    justifyContent="center"
                    height="auto"
                    sx={{ mx: "auto", ml: "-5", alignItems: "center" }}
                  >
                    <MKTypography
                      align="center"
                      pb={2}
                      pt={2}
                      fontSize={32}
                      width="100%"
                      alignItems="end"
                      justifyContent="end"
                      style={{
                        fontFamily: "Barlow",
                        color: colors.JTC.jtcdark3,
                        fontWeight: "600",
                      }}
                    >
                      {
                        clickComplete ? <></> : "0:" + ("00" + count).slice(-2)
                        // <Countdown
                        //   zeroPadDays={2}
                        //   zeroPadTime={2}
                        //   date={Date.now() + constants.warningIn}
                        //   overtime={false}
                        //   renderer={renderer}
                        //   onComplete={onCompleteTimer}
                        // />
                      }
                    </MKTypography>

                    <MKTypography
                      align="center"
                      fontSize={15}
                      style={{
                        fontFamily: "Barlow",
                        color: colors.JTC.jtcdark3,
                        fontWeight: "300",
                        alignItems: "center",
                      }}
                    >
                      Please click "Continue" to keep working
                    </MKTypography>
                    <MKTypography
                      align="center"
                      fontSize={15}
                      style={{
                        fontFamily: "Barlow",
                        color: colors.JTC.jtcdark3,
                        fontWeight: "300",
                        alignItems: "center",
                      }}
                    >
                      or click "Logout" to end your session now.
                    </MKTypography>
                  </MKBox>
                </Grid>
              </Grid>
            </Alert>
          </Grid>

          <Grid item></Grid>
        </Grid>
        <DialogContentText id="alert-dialog-description"></DialogContentText>
      </DialogContent>
      <DialogActions>
        <MKBox
          width="100%"
          display="flex"
          mb={2}
          flexDirection="row"
          justifyContent="space-between"
          height="auto"
        >
          <MKButton
            onClick={handleLogout}
            variant="outlined"
            color="info"
            size="large"
          >
            {" "}
            Logout{" "}
          </MKButton>
          <MKButton onClick={handleClickOpen} color="info" size="large">
            {" "}
            Continue{" "}
          </MKButton>
        </MKBox>
      </DialogActions>
    </Dialog>
  );
}

CountdownDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default CountdownDialog;
